/**!
 * Created by Leonardo Cheslacki on 16/08/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import SupportController from './SupportController';

import config from '../../../../config';

const {default: {text}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class SupportKeyboard extends SupportController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: {},
            count_index: 0,
            disabled: false,
            isCapsLock: false
        };

        this.$temp_key = null;

        this.$inputs = {};

        this.isInput = false;

        this.isShift = false;

        this.$targetMobile = null;

        this.$supportMask = main.$supportMask({});

        _this = this;
    };

    /**
     *
     * @type {{onMouse: function(*): void}}
     */
    $functions = {
        /**
         *
         * @param event
         */
        handleSubmit: function (event) {
            console.log(_this.state);
            // const
            //     {form} = _this.props,
            //     {data, disabled} = _this.state,
            //     _this_frame = _this.getFrame(),
            //     {occ_form} = _this_frame;
            //
            // if (disabled) {
            //     return _this.stopPropagation(event);
            // } else {
            //     _this.stopPropagation(event);
            // }
            //
            // if (_this.inObject(occ_form, 'children')) {
            //     _this.main.postForm(`${_this.$root_uri}/${web.uri_login}`, {[form]: data}, {
            //         beforeSend: () => {
            //             _this.setState({..._this.state, disabled: true});
            //             _this.clearErrors();
            //             _this.focus();
            //             _this.effectFadeIn(_this_frame, 'occ_preload');
            //         },
            //         done: ({status, errors, message, route}) => {
            //             if (Boolean(status)) {
            //                 _this.main.redirectRoute(route);
            //             } else {
            //                 _this.getErrors(errors, message);
            //             }
            //         },
            //         fail: (response) => {
            //             console.log(response);
            //         },
            //         always: () => {
            //             _this.setState({..._this.state, disabled: false});
            //             _this.effectFadeOut(_this_frame, 'occ_preload');
            //         }
            //     });
            // }
        },

        /**
         *
         * @param event
         * @param key
         */
        handleKeyboard: function (event, {key}) {
            _this.throttle('handleKeyboard', () => {
                const
                    {ignore_keys, upper_accent_keys, down_accent_keys} = _this.props,
                    {isCapsLock} = _this.state;

                let decode_key = _this.decodeKey(key, isCapsLock);

                if ((
                        !_this.isEmpty(_this.$temp_key) ||
                        (!isCapsLock && _this.inArray(down_accent_keys, key)) ||
                        (isCapsLock && _this.inArray(upper_accent_keys, key))
                    ) &&
                    !_this.inArray(ignore_keys, decode_key)
                ) {
                    if (!_this.isEmpty(_this.$temp_key)) {
                        let concat_key = `${_this.$temp_key}${decode_key}`;

                        if (_this.$temp_key === decode_key) {
                            decode_key = concat_key;
                        } else {
                            decode_key = _this.decodeKey(concat_key, isCapsLock);
                        }

                        _this.$temp_key = null;
                    } else {
                        _this.$temp_key = decode_key;
                        _this.isShift && _this.switchKey();
                        return false;
                    }
                }

                _this.keydown(false, decode_key);
            }, 100);
        },

        /**
         *
         * @param event
         */
        handleKeydown: function (event) {
            _this.throttle('handleKeydown', () => {
                const key = _this.isMobile() ? ((event.type === 'keydown') ? event.key : event.data) : event.key;
                _this.keydown(event, key);
            }, 100);
        },

        /**
         *
         * @param event
         * @param object
         */
        handleFocus: function (event, {_ref}) {
            _this.throttle('handleFocus', () => {
                const {tab_index} = _ref.state;

                _this.isInput = true;

                _this.setState({..._this.state, count_index: tab_index});

                _this.focus(_ref);

                _this.throttle('handle-focus', () => {
                    _this.isInput = false;
                }, 500);
            }, 100);
        },

        /**
         *
         * @param event
         */
        handleOutFocus: function (event) {
            // console.log(event);
            //
            // _this.stopPropagation(event);
            //
            // if (!_this.isInput) {
            //     _this.setState({..._this.state, count_index: 0});
            //     _this.focus();
            // }
        }
    };

    /**
     *
     * @param string
     * @param secondary
     * @param transform
     * @returns {string}
     */
    decodeKey = (string, secondary = false, transform = 'none') => {
        let sets = [];

        if (secondary) {
            sets = [
                {to: '"', from: 'key_Backquote'},
                {to: '!', from: 'key_1'},
                {to: '@', from: 'key_2'},
                {to: '#', from: 'key_3'},
                {to: '$', from: 'key_4'},
                {to: '%', from: 'key_5'},
                {to: '¨', from: 'key_6'},
                {to: '&', from: 'key_7'},
                {to: '*', from: 'key_8'},
                {to: '(', from: 'key_9'},
                {to: ')', from: 'key_0'},
                {to: 'Enter', from: 'key_Enter'},
                {to: '_', from: 'key_Minus'},
                {to: '+', from: 'key_Equal'},
                {to: 'Backspace', from: 'key_Backspace'},
                {to: 'Q', from: 'key_Q'},
                {to: 'W', from: 'key_W'},
                {to: 'E', from: 'key_E'},
                {to: 'R', from: 'key_R'},
                {to: 'T', from: 'key_T'},
                {to: 'Y', from: 'key_Y'},
                {to: 'U', from: 'key_U'},
                {to: 'I', from: 'key_I'},
                {to: 'O', from: 'key_O'},
                {to: 'P', from: 'key_P'},
                {to: 'A', from: 'key_A'},
                {to: 'S', from: 'key_S'},
                {to: 'D', from: 'key_D'},
                {to: 'F', from: 'key_F'},
                {to: 'G', from: 'key_G'},
                {to: 'H', from: 'key_H'},
                {to: 'J', from: 'key_J'},
                {to: 'K', from: 'key_K'},
                {to: 'L', from: 'key_L'},
                {to: 'Ç', from: 'key_Semicolon'},
                {to: 'Z', from: 'key_Z'},
                {to: 'X', from: 'key_X'},
                {to: 'C', from: 'key_C'},
                {to: 'V', from: 'key_V'},
                {to: 'B', from: 'key_B'},
                {to: 'N', from: 'key_N'},
                {to: 'M', from: 'key_M'},
                {to: '`', from: 'key_BracketLeft'},
                {to: '<', from: 'key_Comma'},
                {to: '>', from: 'key_Period'},
                {to: ':', from: 'key_Slash'},
                {to: '{', from: 'key_BracketRight'},
                {to: '^', from: 'key_Quote'},
                {to: '}', from: 'key_Backslash'},
                {to: '?', from: 'key_IntlRo'},
                {to: '|', from: 'key_IntlBackslash'},
                {to: 'Space', from: 'key_Space'},
                {to: 'ShiftLeft', from: 'key_ShiftLeft'},
                {to: 'ShiftRight', from: 'key_ShiftRight'},
                {to: 'CapsLock', from: 'key_CapsLock'},
                {to: 'Tab', from: 'key_Tab'},
                {to: 'Com', from: 'key_Com'},
                {to: '@', from: 'key_AtSign'},
                {to: 'Á', from: '´A'},
                {to: 'É', from: '´E'},
                {to: 'Í', from: '´I'},
                {to: 'Ó', from: '´O'},
                {to: 'Ú', from: '´U'},
                {to: 'Ã', from: '~A'},
                {to: '~E', from: '~E'},
                {to: '~I', from: '~I'},
                {to: 'Õ', from: '~O'},
                {to: '~U', from: '~U'},
                {to: 'À', from: '`A'},
                {to: 'È', from: '`E'},
                {to: 'Ì', from: '`I'},
                {to: 'Ò', from: '`O'},
                {to: 'Ù', from: '`U'},
                {to: 'Ä', from: '¨A'},
                {to: 'Ë', from: '¨E'},
                {to: 'Ï', from: '¨I'},
                {to: 'Ö', from: '¨O'},
                {to: 'Ü', from: '¨U'},
                {to: 'Â', from: '^A'},
                {to: 'Ê', from: '^E'},
                {to: 'Î', from: '^I'},
                {to: 'Ô', from: '^O'},
                {to: 'Û', from: '^U'}
            ];
        } else {
            sets = [
                {to: '\'', from: 'key_Backquote'},
                {to: '1', from: 'key_1'},
                {to: '2', from: 'key_2'},
                {to: '3', from: 'key_3'},
                {to: '4', from: 'key_4'},
                {to: '5', from: 'key_5'},
                {to: '6', from: 'key_6'},
                {to: '7', from: 'key_7'},
                {to: '8', from: 'key_8'},
                {to: '9', from: 'key_9'},
                {to: '0', from: 'key_0'},
                {to: 'Enter', from: 'key_Enter'},
                {to: '-', from: 'key_Minus'},
                {to: '=', from: 'key_Equal'},
                {to: 'Backspace', from: 'key_Backspace'},
                {to: 'q', from: 'key_Q'},
                {to: 'w', from: 'key_W'},
                {to: 'e', from: 'key_E'},
                {to: 'r', from: 'key_R'},
                {to: 't', from: 'key_T'},
                {to: 'y', from: 'key_Y'},
                {to: 'u', from: 'key_U'},
                {to: 'i', from: 'key_I'},
                {to: 'o', from: 'key_O'},
                {to: 'p', from: 'key_P'},
                {to: 'a', from: 'key_A'},
                {to: 's', from: 'key_S'},
                {to: 'd', from: 'key_D'},
                {to: 'f', from: 'key_F'},
                {to: 'g', from: 'key_G'},
                {to: 'h', from: 'key_H'},
                {to: 'j', from: 'key_J'},
                {to: 'k', from: 'key_K'},
                {to: 'l', from: 'key_L'},
                {to: 'ç', from: 'key_Semicolon'},
                {to: 'z', from: 'key_Z'},
                {to: 'x', from: 'key_X'},
                {to: 'c', from: 'key_C'},
                {to: 'v', from: 'key_V'},
                {to: 'b', from: 'key_B'},
                {to: 'n', from: 'key_N'},
                {to: 'm', from: 'key_M'},
                {to: '´', from: 'key_BracketLeft'},
                {to: ',', from: 'key_Comma'},
                {to: '.', from: 'key_Period'},
                {to: ';', from: 'key_Slash'},
                {to: '[', from: 'key_BracketRight'},
                {to: '~', from: 'key_Quote'},
                {to: ']', from: 'key_Backslash'},
                {to: '/', from: 'key_IntlRo'},
                {to: '\\', from: 'key_IntlBackslash'},
                {to: 'Space', from: 'key_Space'},
                {to: 'ShiftLeft', from: 'key_ShiftLeft'},
                {to: 'ShiftRight', from: 'key_ShiftRight'},
                {to: 'CapsLock', from: 'key_CapsLock'},
                {to: 'Tab', from: 'key_Tab'},
                {to: 'Com', from: 'key_Com'},
                {to: '@', from: 'key_AtSign'},
                {to: 'á', from: '´a'},
                {to: 'é', from: '´e'},
                {to: 'í', from: '´i'},
                {to: 'ó', from: '´o'},
                {to: 'ú', from: '´u'},
                {to: 'ã', from: '~a'},
                {to: '~e', from: '~e'},
                {to: '~i', from: '~i'},
                {to: 'õ', from: '~o'},
                {to: '~u', from: '~u'},
                {to: 'à', from: '`a'},
                {to: 'è', from: '`e'},
                {to: 'ì', from: '`i'},
                {to: 'ò', from: '`o'},
                {to: 'ù', from: '`u'},
                {to: 'ä', from: '¨a'},
                {to: 'ë', from: '¨e'},
                {to: 'ï', from: '¨i'},
                {to: 'ö', from: '¨o'},
                {to: 'ü', from: '¨u'},
                {to: 'â', from: '^a'},
                {to: 'ê', from: '^e'},
                {to: 'î', from: '^i'},
                {to: 'ô', from: '^o'},
                {to: 'û', from: '^u'}
            ];
        }

        string = string.toString().trim();

        sets.forEach((set) => {
            (string === set.from) && (string = set.to);
        });

        if (transform === 'uppercase') {
            return string.toUpperCase();
        } else if (transform === 'lowercase') {
            return string.toLowerCase();
        } else if (transform === 'capitalize') {
            return this.toCapitalize(string);
        } else if (transform === 'capitalize') {
            return this.toCapitalize(string);
        } else {
            return string;
        }
    };

    /**
     *
     * @param name
     */
    clearErrors = (name = null) => {
        const
            {_this_class, submit} = this.props,
            _this_class_current = !submit ? _this_class : this,
            inputs = _this_class_current.$inputs;

        if (!this.isEmpty(name)) {
            let {occ_error} = inputs[name];

            occ_error.text = '';
        } else {
            for (let property in inputs) {
                let {occ_error} = inputs[property];

                occ_error.text = '';
            }
        }
    };

    /**
     *
     * @param errors
     */
    getErrors = (errors) => {
        const
            {_this_class, submit} = this.props,
            _this_class_current = !submit ? _this_class : this,
            inputs = _this_class_current.$inputs;

        for (let property in errors) {
            let
                {occ_error} = inputs[property],
                error = this.getError(errors, property);

            occ_error.text = (error ? error : '');
        }
    };

    /**
     *
     * @param _ref
     */
    focus = (_ref = null) => {
        const
            {_this_class, _this_layer, submit} = this.props,
            _this_class_current = !submit ? _this_class : this,
            {
                stage: {canvas},
                occ_form: {children}
            } = _this_layer,
            document = canvas.ownerDocument;

        for (let property of children) {
            const {occ_caret} = property;
            let status = (_ref === property);
            occ_caret.visible = status;
            this.setStateOccurrence(property, {focus: status});
        }

        if (_ref) {
            canvas.style.outline = 'none';
            canvas.setAttribute('tabindex', '0');
            this.isMobile((response) => {
                if (response) {
                    this.isElement(this.$targetMobile) && this.$targetMobile.remove();
                    this.$targetMobile = document.createElement('input');
                    this.$targetMobile.type = 'text';
                    this.$targetMobile.name = 'target-mobile';
                    this.$targetMobile.id = 'target_mobile';
                    this.$targetMobile.autocomplete = 'off';
                    document.getElementById('animation_container').append(this.$targetMobile);

                    // /**
                    //  *
                    //  *  Add event in the keydown for inputs.
                    //  */
                    // this.removeListener('textInput', 'textInput-canvas',  () => {
                    //     this.addListener(this.$targetMobile, 'textInput', 'textInput-canvas', this.$functions.handleKeydown);
                    // });

                    /**
                     *
                     *  Add event in the keydown for inputs.
                     */
                    _this_class_current.removeListener('keydown', 'keydown-canvas', () => {
                        _this_class_current.addListener(this.$targetMobile, 'keydown', 'keydown-canvas', this.$functions.handleKeydown);
                    });

                    this.$targetMobile.focus();
                } else {
                    /**
                     *
                     *  Add event in the keydown for inputs.
                     */
                    _this_class_current.removeListener('keydown', 'keydown-canvas', () => {
                        _this_class_current.addListener(canvas, 'keydown', 'keydown-canvas', this.$functions.handleKeydown);
                    });

                    canvas.focus();
                }
            });
        } else {
            canvas.removeAttribute('tabindex');
            canvas.blur();
        }
    };

    /**
     *
     * @param children
     */
    cycleTabindex = (children) => {
        this.state.count_index++;
        (this.state.count_index === children.length) && (this.state.count_index = 0);
        this.focus(children[this.state.count_index]);
    };

    /**
     *
     * @param temporary
     */
    switchKey = (temporary = false) => {
        const {_this_layer: {occ_keyboard: {occ_symbol_up, occ_symbol_down, occ_key: {key_CapsLock}}}} = this.props;

        this.isShift = temporary;

        this.state.isCapsLock = !this.state.isCapsLock;

        key_CapsLock.occ_active.visible = this.state.isCapsLock;
        occ_symbol_up.visible = this.state.isCapsLock;
        occ_symbol_down.visible = !this.state.isCapsLock;
    };

    /**
     *
     * @param event
     * @param key
     * @returns {*|boolean}
     */
    keydown = (event = false, key) => {
        const
            {disabled} = this.state,
            {_this_class, _this_layer, _btn_submit, submit, accent_keys} = this.props,
            {occ_form: {children}, occ_message, btn_submit} = _this_layer,
            property = children.find(({state: {focus}}) => Boolean(focus)),
            {name, type, value, mask, placeholder, line_width, value_x, caret_x, maxlength} = property.state,
            {occ_text: {occ_value}, occ_placeholder, occ_caret} = property;

        if (disabled && event) {
            return this.stopPropagation(event);
        }

        this.clearErrors(name);

        // let
        //     bounds_old = occ_value.getBounds(),
        //     width_old = (_this.getObject(bounds_old, 'width') ? bounds_old.width : 0);

        let masked = mask, valued = value;

        if (key === 'Backspace') {
            valued = value.substring(0, value.length - 1);
        } else if (key === 'Space') {
            valued += ' ';
        } else if (key === 'CapsLock') {
            _this.switchKey();
        } else if (key === 'ShiftLeft' || key === 'ShiftRight') {
            _this.switchKey(true);
        } else if (key === 'Com') {
            valued += '.com';
        } else if (key === 'Tab') {
            event && _this.stopPropagation(event);
            _this.cycleTabindex(children);
        } else if (key === 'Enter') {
            if (!submit) {
                _this.dispatch(_btn_submit, 'mousedown');
            } else {
                _this.dispatch(btn_submit, 'mousedown');
            }
        } else if (key.length === 1) {
            _this.isShift && _this.switchKey();
            valued += key;
        } else if (this.inArray(accent_keys, key)) {
            valued += key;
        } else if (event) {
            return _this.stopPropagation(event);
        }

        if (type === 'cell') {
            valued = !_this.isEmpty(valued) ? _this.removeAllSpace(valued) : '';
            masked = this.$supportMask.cell(valued);
            valued = masked;
        } else if (type === 'email') {
            valued = !_this.isEmpty(valued) ? _this.removeAllSpace(valued) : '';
            masked = valued;
        } else if (type === 'password') {
            valued = !_this.isEmpty(valued) ? _this.removeAllSpace(valued) : '';
            masked = '*'.repeat(valued.length);
        } else {
            valued = !_this.isEmpty(valued) ? _this.removeSpaceDuplicate(valued) : '';
            masked = valued;
        }

        if (valued.length > maxlength) {
            if (event) {
                return _this.stopPropagation(event);
            } else {
                return false;
            }
        }

        /**
         * End Mask and limitation
         */

        _this.setStates({data: {[name]: valued}});
        !submit && _this_class.setStates({data: {[name]: valued}});
        _this.setStateOccurrence(property, {mask: masked, value: valued});

        occ_value.text = masked;
        occ_placeholder.text = (occ_value.text ? '' : placeholder);

        let
            bounds = occ_value.getBounds(),
            width_current = (_this.getObject(bounds, 'width') ? bounds.width : 0);
        // width_character = (width_current - width_old);

        if (width_current > line_width) {
            occ_value.textAlign = 'right';
            occ_value.x = line_width;
        } else {
            occ_value.textAlign = 'center';
            occ_value.x = value_x;
            occ_caret.x = (caret_x + (width_current / 2));
        }
    };

    /**
     *
     */
    defineKeyboard = () => {
        const
            {
                _this_class, _this_layer, form, focus, submit,
                text: {cursor, text_align, font_size, font, weight}
            } = this.props,
            _this_class_current = !submit ? _this_class : this,
            {occ_keyboard: {occ_symbol_up, occ_symbol_down, occ_key: {key_CapsLock}}, occ_form} = _this_layer,
            children_input = this.verifyField(_this_layer, 'occ_form.children');

        this.$temp_key = null;
        this.isInput = false;
        this.isShift = false;

        /**
         * Reset input.
         */
        if (!submit) {
            key_CapsLock.occ_active.visible = false;
            occ_symbol_up.visible = false;
            occ_symbol_down.visible = true;
        }

        this.setState({...this.state, count_index: 0, disabled: false, isCapsLock: false});

        if (this.isArrayIf(children_input)) {
            let length = children_input.length;

            for (let i = 0; i < length; i++) {
                const
                    property = children_input[i],
                    {occ_text: {occ_value: {x, lineWidth}}, occ_placeholder: {text}, name, occ_caret} = property;

                let
                    state_name = this.verifyField(property, 'state.name'),
                    state_type = this.verifyField(property, 'state.type'),
                    state_value_x = this.verifyField(property, 'state.value_x'),
                    state_caret_x = this.verifyField(property, 'state.caret_x'),
                    state_line_width = this.verifyField(property, 'state.line_width'),
                    state_placeholder = this.verifyField(property, 'state.placeholder');

                property.cursor = cursor;
                property.occ_text.occ_value.text = '';
                property.occ_text.occ_value.font = `${(!this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${font_size}px '${font}'`;

                property.occ_text.occ_value.textAlign = text_align;
                state_value_x && (property.occ_text.occ_value.x = state_value_x);
                state_caret_x && (property.occ_caret.x = state_caret_x);
                state_placeholder && (property.occ_placeholder.text = state_placeholder);

                let
                    named = name.replace(`${form}_`, ''),
                    typed = this.$supportMask.getMask(name);

                this.setStateOccurrence(property, {
                    name: state_name ? state_name : named,
                    type: state_type ? state_type : typed ? typed : 'text',
                    focus: false,
                    value_x: state_value_x ? state_value_x : x,
                    caret_x: state_caret_x ? state_caret_x : occ_caret.x,
                    line_width: state_line_width ? state_line_width : lineWidth,
                    placeholder: state_placeholder ? state_placeholder : text,
                    tab_index: i,
                    maxlength: 128,
                    value: '',
                    mask: ''
                });

                _this_class_current.$inputs[named] = property;

                if (this.endFor(length, i) && focus) {
                    let input = this.verifyField(occ_form, focus);
                    (focus && input) && this.focus(input);
                }
            }
        }
    };

    startKeyboard = () => {
        const
            {_this_class, _this_layer, focus, submit} = this.props,
            _this_class_current = !submit ? _this_class : this,
            children_key = this.verifyField(_this_layer, 'occ_keyboard.occ_key.children'),
            children_input = this.verifyField(_this_layer, 'occ_form.children');

        if (this.isArrayIf(children_key)) {
            for (let property of children_key) {
                let
                    name = property.name,
                    className = this.toClassName(name);

                _this_class_current[`_handleKeyboard${className}`] && property.off('mousedown', _this_class_current[`_handleKeyboard${className}`]);
                _this_class_current[`_handleKeyboard${className}`] = property.on('mousedown', this.$functions.handleKeyboard, false, false, {
                    key: name
                });
            }
        }

        if (this.isArrayIf(children_input)) {
            let
                length = children_input.length,
                {occ_form, btn_submit} = _this_layer;

            for (let i = 0; i < length; i++) {
                const
                    property = children_input[i],
                    {name} = property,
                    className = this.toClassName(name);

                _this_class_current[`_handleFocus${className}`] && property.off('mousedown', _this_class_current[`_handleFocus${className}`]);
                _this_class_current[`_handleFocus${className}`] = property.on('mousedown', this.$functions.handleFocus, false, false, {_ref: property});

                if (this.endFor(length, i) && focus) {
                    this.defineKeyboard();
                    let input = this.verifyField(occ_form, focus);
                    (focus && input) && this.focus(input);
                }
            }

            _this_class_current._handleOutFocus && _this_layer.off('mousedown', this._handleOutFocus);
            _this_class_current._handleOutFocus = _this_layer.on('mousedown', this.$functions.handleOutFocus);

            if (submit) {
                _this_class_current._handleSubmit && btn_submit.off('mousedown', this._handleSubmit);
                _this_class_current._handleSubmit = btn_submit.on('mousedown', this.$functions.handleSubmit);
            }
        }
    };

    /**
     * Create listeners.
     */
    initKeyboard = () => {
        this.startKeyboard();
    };
}

/**
 *
 * @type {{}}
 */
SupportKeyboard.propTypes = {
    _this_class: PropTypes.object,
    _this_layer: PropTypes.object,
    form: PropTypes.string,
    focus: PropTypes.string,
    submit: PropTypes.bool,
    ignore_keys: PropTypes.array,
    upper_accent_keys: PropTypes.array,
    down_accent_keys: PropTypes.array,
    accent_keys: PropTypes.array,
    text: PropTypes.object
};

/**
 *
 * @type {{}}
 */
SupportKeyboard.defaultProps = {
    _this_class: {},
    _this_layer: {},
    form: 'auth',
    focus: null,
    submit: false,
    ignore_keys: ['Backspace', 'Space', 'CapsLock', 'ShiftLeft', 'ShiftRight', 'Com', 'Tab', 'Enter'],
    upper_accent_keys: ['key_6', 'key_BracketLeft', 'key_Quote'],
    down_accent_keys: ['key_BracketLeft', 'key_Quote'],
    accent_keys: ['´´', '~~', '¨¨', '``', '^^', '~e', '~i', '~u', '~E', '~I', '~U'],
    text: {
        ...text,
        cursor: 'text',
        text_align: 'center',
        font_size: 25
    }
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(SupportKeyboard, {className: 'SupportKeyboard'});
